export const LEGACY_DECISION_PIECE_TYPES = [
  'attendance_decided',
  'date_selection_decided',
  'decision_made',
] as const;

const LEGACY_DECISION_PIECE_TYPE_SET = new Set<string>(LEGACY_DECISION_PIECE_TYPES);

export function isLegacyDecisionSourcePiece(sourcePiece: unknown): boolean {
  if (typeof sourcePiece !== 'string') return false;
  const pieceType = sourcePiece.split(':')[0] || '';
  return LEGACY_DECISION_PIECE_TYPE_SET.has(pieceType);
}

export function isDecisionSurfaceReady(st: { metadata?: Record<string, unknown> | null; source_piece?: string | null }): boolean {
  const surface = st.metadata?.judgment_surface;
  if (!surface || typeof surface !== 'object' || Array.isArray(surface)) {
    return isLegacyDecisionSourcePiece(st.source_piece);
  }
  const judgmentSurface = surface as Record<string, unknown>;
  return judgmentSurface.make_decision_available === true ||
    judgmentSurface.readiness === 'awaiting_user_judgment';
}
